/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedLaborCostDtoPage } from '../../models/planned-labor-cost-dto-page';

export interface ListPlannedLaborCosts$Params {
  budgetId?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'hours' | '-hours' | 'comment' | '-comment' | 'amount' | '-amount' | 'isCalculated' | '-isCalculated' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'laborCost' | '-laborCost' | 'budget' | '-budget'>;
}

export function listPlannedLaborCosts(http: HttpClient, rootUrl: string, params?: ListPlannedLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedLaborCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listPlannedLaborCosts.PATH, 'get');
  if (params) {
    rb.query('budgetId', params.budgetId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedLaborCostDtoPage>;
    })
  );
}

listPlannedLaborCosts.PATH = '/v0/plannedLaborCosts';
